import React, { createContext, useContext, useState } from 'react';
import PermissionModal from './PermissionModal';

interface PermissionModalContextType {
    showPermissionModal: (message: string, title?: string) => void;
}

const PermissionModalContext = createContext<PermissionModalContextType | undefined>(undefined);

export const PermissionModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalTitle, setModalTitle] = useState('Action not allowed');

    const showPermissionModal = (message: string, title = 'Action not allowed') => {
        setModalMessage(message);
        setModalTitle(title);
        setIsOpen(true);
    };

    return (
        <PermissionModalContext.Provider value={{ showPermissionModal }}>
            {children}
            <PermissionModal
                open={isOpen}
                setOpen={setIsOpen}
                message={`${modalMessage}, please speak with your site Administrator.`}
                title={modalTitle}
            />
        </PermissionModalContext.Provider>
    );
};

export const usePermissionModal = (): PermissionModalContextType => {
    const context = useContext(PermissionModalContext);
    if (context === undefined) {
        throw new Error('usePermissionModal must be used within a PermissionModalProvider');
    }
    return context;
};